import { Chip } from '@heroui/react';
import type { UsageStatus, UsageType } from '../../api/my-parking-spots';
import {
  getUsageStatusChipColor,
  getUsageStatusLabel,
  getUsageTypeChipColor,
  getUsageTypeLabel,
} from '../../features/my-parking-spots/utils/usage-display';

export function UsageStatusChip({
  status,
  className,
}: {
  status: UsageStatus | string;
  className?: string;
}) {
  return (
    <Chip size="sm" variant="soft" color={getUsageStatusChipColor(status)} className={className}>
      {getUsageStatusLabel(status)}
    </Chip>
  );
}

export function UsageTypeChip({
  type,
  className,
}: {
  type: UsageType | string;
  className?: string;
}) {
  return (
    <Chip size="sm" variant="soft" color={getUsageTypeChipColor(type)} className={className}>
      {getUsageTypeLabel(type)}
    </Chip>
  );
}
